import { OrganizationListItem } from "@gsx/common/src/types/http/admin/organization";
import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../../common/src/stores/CollectionStore";

@Module()
export class OrganizationCollectionStore extends CollectionStore<OrganizationListItem> {
    sort: keyof OrganizationListItem = "organizationName";
}
